import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
import UserAvatar from "../components/UserAvatar";
import moment from 'moment'
import { toast } from "sonner";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CheckBoxIcon from "@mui/icons-material/CheckBox";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
// import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
// import VisibilityIcon from '@mui/icons-material/Visibility';

// import CheckIcon from '@mui/icons-material/Check';
// import EditIcon from '@mui/icons-material/Edit';
// import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
// import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';

// import { DeleteConfirmationModal } from "../components/AppModal";
import { useUpdateMembership } from '../hooks/memberhooks'
// import { statusColors } from "../utils/enums";
import { styleThousandCommas, getMemberStatusColor, getMemberStatusUpdateOptions } from "../utils/helpers";
import { MembershipSchema, MembershipStatusType, MemberRecordDropdownOptionsType } from "../data/types";
// import { MembershipSchema } from "../data/types";


// const colors: {[key: string]: string} = statusColors();
// const account_avatar = `https://upload.wikimedia.org/wikipedia/commons/1/1e/Default-avatar.jpg`

// const circle = (status: string) => {
//   return (
//     <span
//       className={`z-0 w-2 h-2 animate-pulse ${colors[status]} rounded-full`}
//     ></span>
//   );
// };

type MemberRecordProps = {
  member: MembershipSchema
  allSelected: boolean
  isRequests?: boolean
  onViewMemberDetails?: () => void
  onViewSendMessage?: () => void
  // onUpdateMember?: (member: MembershipSchema) => void
  // setEditMember: React.Dispatch<React.SetStateAction<string>>
}

const MemberRecord: React.FC<MemberRecordProps> = (props) => {
  // var navigate = useNavigate();

  // const [is_open, openCheck] = useState(false);
  // const [isClicked, setClick] = useState(false);
  const [selected, updateSelect] = useState(false);
  const [imageError, setImageError] = useState(false);

  var { member, isRequests, onViewMemberDetails, onViewSendMessage } = props
  const [dropdownIsOpen, toggleDropdownIsOpen] = useState(false);
  // const [newMember, setMember] = useState<DSCommunitySchema>(member);
  const memberUid = member?.uid || "";
  const { updateMembership } = useUpdateMembership(memberUid)

  // const updateOpenView = () => {
  //   navigate(`/kitchens/members/${member.id}`) 
  //   // openCheck(true);
  // }

  // const updateCloseView = () => {
  //   openCheck(false);
  // };

  // const approveRequest = () => {
  //  if (updateMembership !== undefined) {
  //     updateMembership({username: member.username, status: 'approved'})
  //  } 
  // }

    // const submitUpdate = (membershipChanges: MembershipSchema) => {
    //   updateMembership(membershipChanges)
    // }

  // const declineRequest = () => {
  //   if (updateMembership !== undefined) {
  //     updateMembership({username: member.username, status: member.status === 'declined' ? 'removed' : 'declined'})
  //   } 
  // }

  const handleUpdateMember = async (member: MembershipSchema) => {
    // console.log('member', member)
    if (updateMembership !== undefined && member){
      const updated = await updateMembership(member)
      // console.log("updated", updated)
      if (updated) {
        toast.success("Member updated successfully")
      } else {
        toast.error("Failed to update member")
      }
    } else {
      toast.error("Failed to update member")
    }
  }

  const handleViewMemberDetails = () => {
    if (onViewMemberDetails) {
      onViewMemberDetails()
    }
  }

  const handleViewSendMessage = () => {
    if (onViewSendMessage) {
      onViewSendMessage()
    }
  }

  const membershipStatuses = getMemberStatusUpdateOptions(member?.status as MembershipStatusType)
  const statusColors = getMemberStatusColor(member.status || '')

  return member ? (
    <tr className="hover:bg-gray-50">
      <td className="px-6 py-4 whitespace-nowrap">
        {props.allSelected ? (
          <CheckBoxIcon
            className="cursor-pointer text-gray-500"
            onClick={() => updateSelect(false)}
          />
        ) : selected ? (
          <CheckBoxIcon
            className="cursor-pointer text-gray-500"
            onClick={() => updateSelect(false)}
          />
        ) : (
          <CheckBoxOutlineBlankIcon
            className="cursor-pointer text-gray-500"
            onClick={() => updateSelect(true)}
          />
        )}
      </td>

      <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => handleViewMemberDetails()}>
        {member.first_name ? (
          <span className="flex items-center">
            {member.avatar && !imageError ? (
              <img
                src={member.avatar}
                alt="User Avatar"
                className="w-8 h-8 rounded-full mr-3"
                onError={() => setImageError(true)}
              />
            ) : (
              <UserAvatar
                firstName={member?.first_name}
                lastName={member?.last_name}
                username={member?.username}
                email={member?.email}
                size="sm"
                className="mr-3"
              />
            )}
            <span className="text-sm text-gray-900">
              {member?.first_name} {member?.last_name}
            </span>
          </span>
        ) : (
          <span className="text-sm text-gray-400">N/A</span>
        )}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 cursor-pointer" onClick={() => handleViewMemberDetails()}>
        {member.username}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {member?.team_name || "-"}
      </td>

      <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => handleViewMemberDetails()}>
        <span className="flex items-center">
          {/* {circle(member.status as MembershipStatusType)} */}
          <span 
            className="flex flex-row items-center text-sm font-open-sans font-semibold" 
            style={{
              color: statusColors.primaryTextColor, 
              // backgroundColor: getMemberStatusColor(member.status || '').bgColor
            }}
          >
            <span className="w-3 h-3 rounded-full flex items-center justify-center" style={{ backgroundColor: statusColors.bgColor }}>
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: statusColors.primaryTextColor }} />
            </span>
            &nbsp; {(member.status) ? member.status.replace(/\b\w/g, (status: string) => status.toUpperCase()) : 'Pending'}
          </span>
        </span>
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 cursor-pointer" onClick={() => handleViewMemberDetails()}>
        {(member && member?.plan_rate && member?.plan_rate.toString().includes(".")) ? (
          `$${styleThousandCommas(member.plan_rate?.toFixed(2).toString() || "0.00")} (${member.plan_recurrence})`
        ) : (
          `$${styleThousandCommas(member?.plan_rate ? member?.plan_rate?.toFixed(2).toString() || "0.00" : "0.00")} (${member.plan_recurrence})`
        )}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {(member && (member?.member_balance || member?.member_balance === 0)) ? (
          `${styleThousandCommas(member.member_balance.toString())} hours`
        ) : (
          `-`
        )}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 cursor-pointer" onClick={() => handleViewMemberDetails()}>
        {moment.utc(member?.joined).fromNow()}
      </td>

      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
        {isRequests ? (
          <span className="flex items-center space-x-3">
            {/* <EditIcon
              className="cursor-pointer text-[#013847] hover:text-[#012a35]"
            />
            {member?.status === 'declined' ? (
              <DoNotDisturbIcon 
                className="cursor-pointer text-[#EB001B] hover:text-[#cc0018]"
              />
            ) : (
              <DeleteIcon
                className="cursor-pointer text-[#EB001B] hover:text-[#cc0018]"
              />
            )} */}
            <InfoIcon
              className="cursor-pointer text-[#5DB6CE] hover:text-[#4a9db3]"
              onClick={() => handleViewMemberDetails()}
            />
          </span>
        ) : (
          <span className="flex items-center">
            <span 
              className="flex h-8 w-8 rounded-full border-2 border-gray-300 cursor-pointer hover:border-gray-400"
              onClick={()=>toggleDropdownIsOpen(prev=>!prev)}
            >
              <MoreHorizIcon className="m-auto text-gray-500" style={{fontSize: 16}} />
            </span>
            <Dropdown 
              username={member?.username as string}
              membershipStatuses={membershipStatuses} 
              showDropdown={dropdownIsOpen} 
              toggleShowDropdown={toggleDropdownIsOpen} 
              toggleViewMemberDetails={handleViewMemberDetails} 
              handleUpdateMember={handleUpdateMember}
              toggleViewSendMessage={handleViewSendMessage}
            />
          </span>
        )}
      </td>
    </tr>
  ) : null;
};

export default MemberRecord;


type DropdownProps = {
  // selectedOption: any
  // handleSelectOption: (option: any) => void
  username: string
  showDropdown: boolean
  membershipStatuses: MemberRecordDropdownOptionsType[]
  toggleShowDropdown: React.Dispatch<React.SetStateAction<boolean>>
  toggleViewMemberDetails: () => void
  handleUpdateMember: (member: MembershipSchema) => void
  toggleViewSendMessage: () => void
}

const Dropdown: React.FC<DropdownProps> = ({username, showDropdown, membershipStatuses, toggleViewSendMessage, toggleShowDropdown, toggleViewMemberDetails, handleUpdateMember}) => {

  const handleClickDropdown = (option: MembershipStatusType) => {
    if (option) {
      const statusUpdate = {
        username, 
        status: option
      }
      // console.log('statusUpdate', statusUpdate)
      handleUpdateMember(statusUpdate)
      toggleShowDropdown(false)
    }

    // console.log('option', option)
    
  };

  const handleOptionClick = (option: string) => {
    switch(option) {
      // case 'manage-status':
      //   // Handle status management
      //   break;
      case 'details':
        toggleViewMemberDetails();
        break;
      case 'message':
        // switchMember(username);
        toggleViewSendMessage();
        break;
      default:
        handleClickDropdown(option as MembershipStatusType);
        break;
    }
    toggleShowDropdown(false);
  };

  return (
    <span className="relative">
      {/* Dropdown Menu */}
      {
        (showDropdown) && (
        <ul 
          className="absolute w-auto right-8 mt-1 border border-gray-200 rounded-lg bg-white shadow-lg z-50"
          onMouseLeave={() => toggleShowDropdown(false)}
        >
          {membershipStatuses.map((option, i) => {
            const IconComponent = option.icon;
            return (
              <span
                key={i}
                className={`flex flex-row items-center font-open-sans text-left text-[14px] font-medium cursor-pointer px-3 py-2 hover:bg-gray-100 ${option.textColor} ${option.bgColor} ${i !== membershipStatuses.length - 1 ? 'border-b border-gray-100' : ''}`}
                onClick={() => handleOptionClick(option.value)}
              >
                {IconComponent && (
                  <IconComponent style={{fontSize: 18}} className={`${option.textColor || 'text-[#A1A1A1]/70'}`} />
                )}
                <p className="text-[14px] font-medium mx-2">{option.label}</p>
              </span>
            );
          })}
        </ul>)
      }
    </span>
  );
};
